<template>
    <div class="personWrapper">
    <img class="person" src="@/assets/person.svg">
    <div class="login">Login</div>
</div>
</template>

<style scoped>

.person {
    width:60%;
}

.login {
    color: black;
}

</style>